import core from './core';
import { DeviceManager } from './DeviceManager';
import { Glossary } from '../helpers/Glossary';

const FlyoutController = core.extend({
	constructor(opts) {
		if (DeviceManager.hasOrientation()) {
			return;
		}

		this.data = {
			product: _.find(opts.data.concreteProducts, (object) => object.format === opts.data.preConfig.format),
		};

		this.attachEvents(opts);
	},

	attachEvents(opts) {
		opts.el.find(opts.actionElement).each((i, el) => {
			el = jQuery(el);

			el.off(opts.eventOn, opts.control).on(opts.eventOn, opts.control, (e) => this.updateFlyout(e, el, opts));

			el.off(opts.eventOff, opts.control).on(opts.eventOff, opts.control, (e) => this.updateFlyout(e, el, opts));
		});
	},

	updateFlyout(e, el, opts) {
		// formats which contain a wooden block, but are not a calendar
		const exceptFormat = ['F071', 'F072', 'F501'];

		if (jQuery(el).hasClass('woodenBlock-select') && exceptFormat.includes(this.data.product.format)) {
			return;
		}

		const flyout = jQuery(el).find(opts.flyoutElement);

		if (flyout.length === 0) {
			return;
		}

		e.currentTarget.classList.contains('is-disabled') ||
		e.currentTarget.classList.contains('is-disabled-because-refinement') ||
		e.currentTarget.classList.contains('is-disabled-because-frame')
			? flyout.addClass('is-disabled')
			: flyout.removeClass('is-disabled');

		e.type === opts.eventOn ? this.showFlyout(e, el, flyout) : flyout.hide();
	},

	showFlyout(e, el, flyout) {
		const control = jQuery(e.currentTarget);
		const option = this.retrieveOption(control);
		const desc = option && option.description;

		if (!option || !option.key || !desc || option.key.slice(1, 3) === '00') {
			return;
		}

		this.changeFlyoutImage(option, flyout);

		flyout.find('.description').html(desc);

		const top = control.offset().top - jQuery(el).offset().top;

		flyout.css({ top }).show();
	},

	retrieveOption(control) {
		const data = control.data();
		const key = data.value.split(':')[0];
		const optionsMapping = {
			paper: 'papers',
			woodenBlock: 'woodenBlocks',
			box: 'box',
			refinement: 'refinements',
			outerPaper: 'outerPapers',
			diecut: 'diecuts',
			frame: 'frames',
			tag: 'tags',
			ribbon: 'ribbons',
		};

		return _.find(
			this.data.product.productOptions[optionsMapping[key]] || [],
			(opt) => opt.key === data[key.toLowerCase()]
		);
	},

	changeFlyoutImage(option, flyout) {
		const flyoutImage = option.type ? `${option.key}-${option.type}` : option.key;
		const frontendTheme = window.frontendTheme || 'kam';
		const tagToHideFlyout = Glossary.TAG_SKU;

		if (flyoutImage === tagToHideFlyout) {
			// this exception is needed because we don't want to show the image for the T01 flyout
			flyout.find('.image').addClass('is-hidden');
		} else {
			flyout
				.find('.image')
				.removeClass('is-hidden')
				.attr('src', `/${frontendTheme}/images/images/flyout-images/${flyoutImage}.jpg`);
		}
	},
});

export default FlyoutController;
